/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Select_All_BeforeInputs */

const en_context_menu_select_all_before = /** @type {(inputs: Context_Menu_Select_All_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select All Before`)
};

const fr_context_menu_select_all_before = /** @type {(inputs: Context_Menu_Select_All_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez tout avant`)
};

const de_context_menu_select_all_before = /** @type {(inputs: Context_Menu_Select_All_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle auswählen, bevor`)
};

const it_context_menu_select_all_before = /** @type {(inputs: Context_Menu_Select_All_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona tutto prima`)
};

const ru_context_menu_select_all_before = /** @type {(inputs: Context_Menu_Select_All_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбрать все перед`)
};

const es_context_menu_select_all_before = /** @type {(inputs: Context_Menu_Select_All_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar todo antes`)
};

const zh_cn2_context_menu_select_all_before = /** @type {(inputs: Context_Menu_Select_All_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在选择之前全部选中`)
};

const ja_context_menu_select_all_before = /** @type {(inputs: Context_Menu_Select_All_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて選択する`)
};

const hi_context_menu_select_all_before = /** @type {(inputs: Context_Menu_Select_All_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी का चयन करें`)
};

const pt_pt2_context_menu_select_all_before = /** @type {(inputs: Context_Menu_Select_All_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione tudo antes de`)
};

/**
* | output |
* | --- |
* | "Select All Before" |
*
* @param {Context_Menu_Select_All_BeforeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_select_all_before = /** @type {((inputs?: Context_Menu_Select_All_BeforeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Select_All_BeforeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_select_all_before(inputs)
	if (locale === "de") return de_context_menu_select_all_before(inputs)
	if (locale === "it") return it_context_menu_select_all_before(inputs)
	if (locale === "ru") return ru_context_menu_select_all_before(inputs)
	if (locale === "es") return es_context_menu_select_all_before(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_select_all_before(inputs)
	if (locale === "ja") return ja_context_menu_select_all_before(inputs)
	if (locale === "hi") return hi_context_menu_select_all_before(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_select_all_before(inputs)
	return en_context_menu_select_all_before(inputs)
});